import { elementAngleichen, schriftenAngleichen } from "@js/campaigns/schrift-angleichen";

document.addEventListener("DOMContentLoaded", async () => {
  const currentTheme = localStorage.getItem("theme") || "dark";
  document.documentElement.setAttribute("data-bs-theme", currentTheme);

  const builder = document.getElementById("vvveb-builder");
  if (!builder) return;

  const config = window.campaignStructureConfig;
  if (!config) {
    console.warn("campaignStructureConfig not found");
    return;
  }

  // --- EDITOR SPERRE / LOCK ---
  const csrfToken = document.querySelector("meta[name='_csrf']")?.getAttribute("content");
  const csrfHeader = document.querySelector("meta[name='_csrf_header']")?.getAttribute("content");
  if (csrfToken && csrfHeader && config.campaignId) {
    // Heartbeat senden (alle 10 Sek)
    setInterval(() => {
      fetch(`/campaigns/${config.campaignId}/heartbeat`, {
        method: "POST",
        headers: { [csrfHeader]: csrfToken },
      }).catch((e) => console.debug("Heartbeat fehlgeschlagen", e));
    }, 10000);

    // Lock beim Verlassen freigeben
    window.addEventListener("beforeunload", () => {
      fetch(`/campaigns/${config.campaignId}/unlock`, {
        method: "POST",
        headers: { [csrfHeader]: csrfToken },
        keepalive: true,
      }).catch((e) => console.debug("Unlock fehlgeschlagen", e));
    });
  }
  // -----------------------------

  // dynamisches laden der inputs.html damit es nicht durch thymeleaf html parser läuft
  if (config.inputsUrl) {
    try {
      const inputsResponse = await fetch(config.inputsUrl);
      if (inputsResponse.ok) {
        const html = await inputsResponse.text();
        builder.parentElement.insertAdjacentHTML("beforeend", html);
      }
    } catch (error) {
      console.error("Error fetching inputsUrl:", error);
    }
  }

  // --- SCHRIFTARTEN ---
  // Gelten für alle Seiten der Kampagne. Im Builder kommen sie als Hilfs-Link in den Rahmen, den
  // removeHelpers beim Speichern entfernt, damit sie nicht in die Seite selbst geschrieben werden.
  const schriftFelder = {
    ueberschrift: document.getElementById("cs-schrift-ueberschrift"),
    text: document.getElementById("cs-schrift-text"),
  };

  // Erfüllt sich, sobald die Schriften im Rahmen gelten, damit der Stil-Tab danach die
  // neue Schrift anzeigt
  function schriftenInRahmen() {
    const head = window.FrameDocument?.head;
    if (!head || !config.schriftenCssUrl) return Promise.resolve();

    head.querySelector("#cs-schriften")?.remove();
    const link = document.createElement("link");
    link.id = "cs-schriften";
    link.rel = "stylesheet";
    link.setAttribute("data-vvveb-helpers", "");
    link.href = `${config.schriftenCssUrl}?v=${Date.now()}`;
    const geladen = new Promise((resolve) => {
      link.onload = link.onerror = resolve;
    });
    head.append(link);
    return geladen;
  }
  window.addEventListener("Vvveb.iframe.loaded", schriftenInRahmen);

  // Schriftstärke, Zeichenabstand und Schriftstil je Schrift, leer = wie in der Vorlage. Gebaut
  // aus denselben Eingaben und Vorlagen wie die Typografie im Stil-Tab, damit sie gleich aussehen
  // und sich gleich bedienen.
  const schnittFelder = {};
  // Wie im Stil-Tab: den Wert setzen, solange die Eingabe noch nicht eingehängt ist, denn ihr
  // element ist eine Live-Collection, die nach dem Einhängen leer ist. Zurück kommt die Wurzel.
  const schnittZeile = (container, eingabe, data, property, wert) => {
    const input = { ...eingabe };
    const element = input.init({ key: property.key, ...data });
    input.setValue(wert);
    const zeile = generateElements(tmpl("vvveb-property", property))[0];
    zeile.querySelector(".input").append(element);
    container.append(zeile);
    return element;
  };
  const baueSchnitt = (art, wert) => {
    const container = document.querySelector(`.cs-schrift-schnitt[data-art="${art}"]`);
    // die Eingaben sind im Builder mit let deklariert und hängen deshalb nicht an window
    if (!container || typeof tmpl !== "function" || typeof SelectInput === "undefined") return null;

    const gewichte = Vvveb.Components.getProperty("_base", "font-weight")?.data.options ?? [
      { value: "", text: "Standard" },
    ];
    const staerke = schnittZeile(
      container,
      SelectInput,
      { options: gewichte },
      {
        key: `cs-${art}-staerke`,
        name: "Schriftstärke",
        col: 6,
        inline: false,
        help: "Dicke der Schriftzeichen, nur Stärken, die es von der Schrift gibt",
      },
      wert.staerke || "",
    );
    const abstand = schnittZeile(
      container,
      CssUnitInput,
      {},
      {
        key: `cs-${art}-abstand`,
        name: "Zeichenabstand",
        col: 6,
        inline: false,
        help: "Abstand zwischen einzelnen Buchstaben",
      },
      wert.abstand || "",
    );
    // ohne Wert in px, der häufigsten Einheit für den Zeichenabstand
    if (!wert.abstand) abstand.querySelector("select").value = "px";
    const stil = schnittZeile(
      container,
      RadioButtonInput,
      {
        extraclass: "btn-group-sm btn-group-fullwidth",
        options: [
          { value: "normal", icon: "la la-times", title: "Normal", checked: true },
          { value: "italic", icon: "la la-italic", title: "Kursiv" },
        ],
      },
      { key: `cs-${art}-stil`, name: "Schriftstil", col: 12, inline: false },
      wert.kursiv ? "italic" : "normal",
    );

    return { staerke: staerke.querySelector("select"), abstand, stil };
  };

  if (schriftFelder.ueberschrift && schriftFelder.text && config.schriftenUrl) {
    schriftFelder.ueberschrift.value = config.schriftUeberschrift || "";
    schriftFelder.text.value = config.schriftText || "";
    // ein Fehler hier darf nur diese Zeilen kosten, nicht das Laden des ganzen Editors
    for (const art of Object.keys(schriftFelder)) {
      try {
        const felder = baueSchnitt(art, config.schnitte?.[art] ?? {});
        if (felder) schnittFelder[art] = felder;
      } catch (error) {
        console.error("Schriftschnitt konnte nicht angezeigt werden", error);
      }
    }

    let schriften = new Set();
    let katalog = {};

    // Stärken, die es von der gewählten Schrift nicht gibt, sind nicht wählbar; ohne Schrift
    // gilt die der Vorlage und jede Stärke bleibt möglich
    const staerkenAnpassen = (art) => {
      const auswahl = schnittFelder[art]?.staerke;
      if (!auswahl) return;
      const vorhanden = katalog[schriftFelder[art].value.trim()]?.variants?.normal;
      for (const option of auswahl.options) {
        option.disabled = !!option.value && !!vorhanden && !(option.value in vorhanden);
      }
      if (auswahl.selectedOptions[0]?.disabled) auswahl.value = "";
    };

    fetch("/vvvebjs/resources/google-fonts.json")
      .then((response) => response.json())
      .then((data) => {
        katalog = data;
        schriften = new Set(Object.keys(data));
        Object.keys(schriftFelder).forEach(staerkenAnpassen);
      })
      .catch((error) => console.error("Schriftarten konnten nicht geladen werden", error));

    const daten = () => {
      const werte = {};
      for (const [art, feld] of Object.entries(schriftFelder)) {
        const schnitt = schnittFelder[art];
        const zahl = schnitt?.abstand.querySelector("input").value.trim() ?? "";
        const einheit = schnitt?.abstand.querySelector("select").value || "px";
        werte[art] = feld.value.trim();
        werte[`${art}Staerke`] = schnitt?.staerke.value || "";
        werte[`${art}Kursiv`] = String(
          schnitt?.stil.querySelector("input:checked")?.value === "italic",
        );
        // als Zahl normalisiert: CssUnitInput.setValue zieht die Zahl per Text ab, aus 1.50px
        // würde beim Laden sonst die Einheit „0px“
        werte[`${art}Abstand`] =
          zahl === "" || einheit === "auto" || !Number.isFinite(Number(zahl))
            ? ""
            : Number(zahl) + einheit;
      }
      return werte;
    };
    let gespeichert = JSON.stringify(daten());

    // leise: Stärke, Kursiv und Abstand ändert man oft mehrmals hintereinander, dafür nur ein
    // kleiner Toast statt des Dialogs
    const speichereSchriften = async (feld = null, leise = false) => {
      if (feld) {
        const wert = feld.value.trim();
        if (wert && schriften.size > 0 && !schriften.has(wert)) {
          feld.classList.add("is-invalid");
          cs.notifyError(`„${wert}“ ist keine bekannte Schriftart.`, "Schriftarten");
          return false;
        }
        feld.classList.remove("is-invalid");
      }
      Object.keys(schriftFelder).forEach(staerkenAnpassen);

      const werte = daten();
      if (JSON.stringify(werte) === gespeichert) return true;
      const vorher = JSON.parse(gespeichert);

      const response = await fetch(config.schriftenUrl, {
        method: "POST",
        headers: csrfToken && csrfHeader ? { [csrfHeader]: csrfToken } : {},
        body: new URLSearchParams(werte),
      }).catch(() => null);

      if (!response || !response.ok) {
        cs.notifyError("Schriftarten konnten nicht gespeichert werden.", "Fehler");
        return false;
      }
      gespeichert = JSON.stringify(werte);
      await schriftenInRahmen();

      // Elemente mit eigener Schrift behalten sie; nachfragen, ob sie mitgehen sollen. Das
      // gilt nur für einen neuen Schriftnamen, nicht für Stärke, Kursiv oder Abstand.
      let gefragt = false;
      for (const art of Object.keys(schriftFelder)) {
        if (!werte[art] || werte[art] === vorher[art]) continue;
        try {
          gefragt =
            (await schriftenAngleichen({
              art,
              name: werte[art],
              config,
              seiten: {
                offen: isCurrentPageDanke() ? "danke" : "main",
                urls: { main: config.rawStructureUrl, danke: config.rawDankeStructureUrl },
              },
              speichern: seiteSpeichern,
            })) || gefragt;
        } catch (error) {
          console.error("Eigene Schriftarten konnten nicht geprüft werden", error);
        }
      }
      if (gefragt) return true;

      cs.notifySuccess(
        "Schriftarten gespeichert, sie gelten für alle Seiten.",
        "Schriftarten",
        leise
          ? {
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              backdrop: false,
              timer: 2000,
            }
          : undefined,
      );
      return true;
    };

    // Für die Seite, die beim Angleichen der Schriften nicht im Editor offen ist
    const seiteSpeichern = async (html, typ) => {
      const response = await fetch(config.saveStructureUrl, {
        method: "POST",
        headers: csrfToken && csrfHeader ? { [csrfHeader]: csrfToken } : {},
        body: new URLSearchParams({
          html,
          type: typ,
          file: typ === "danke" ? "danke.html" : "index.html",
        }),
      }).catch(() => null);
      return Boolean(response?.ok);
    };

    // die Eingaben melden jede Änderung als propertyChange, der Zeichenabstand schon beim
    // Tippen, deshalb wird kurz gewartet
    let schnittTimer;
    for (const felder of Object.values(schnittFelder)) {
      [felder.staerke.parentElement, felder.abstand, felder.stil].forEach((element) =>
        element.addEventListener("propertyChange", () => {
          clearTimeout(schnittTimer);
          schnittTimer = setTimeout(() => speichereSchriften(null, true), 500);
        }),
      );
    }

    // „Für die ganze Seite übernehmen“ unter der Schriftart im Stil-Tab landet hier, in
    // denselben Feldern wie im Design-Tab
    if (window.Vvveb?.FontsManager) {
      Vvveb.FontsManager.onPageFont = async (art, name, element) => {
        const feld = art === "heading" ? schriftFelder.ueberschrift : schriftFelder.text;
        feld.value = name;
        if (!(await speichereSchriften(feld))) return false;
        await elementAngleichen({
          element,
          art: art === "heading" ? "ueberschrift" : "text",
          config,
        }).catch((error) => console.error("Schrift am Element nicht angeglichen", error));
        return true;
      };
    }

    Object.values(schriftFelder).forEach((feld) => {
      const liste = feld.nextElementSibling;

      const schliessen = () => liste.classList.remove("show");
      const waehlen = (name) => {
        feld.value = name;
        schliessen();
        speichereSchriften(feld);
      };
      const zeigen = () => {
        const suche = feld.value.trim().toLowerCase();
        const beginnt = (name) => name.toLowerCase().startsWith(suche);
        const treffer = [...schriften]
          .filter((name) => name.toLowerCase().includes(suche))
          .sort((a, b) => beginnt(b) - beginnt(a))
          .slice(0, 50);

        liste.replaceChildren(
          ...treffer.map((name) => {
            const eintrag = document.createElement("button");
            eintrag.type = "button";
            eintrag.className = "dropdown-item";
            eintrag.textContent = name;
            const li = document.createElement("li");
            li.append(eintrag);
            return li;
          }),
        );
        liste.classList.toggle("show", treffer.length > 0);
      };

      feld.addEventListener("focus", zeigen);
      feld.addEventListener("input", zeigen);
      feld.addEventListener("blur", schliessen);
      feld.addEventListener("change", () => speichereSchriften(feld));

      // mousedown würde dem Feld den Fokus nehmen und die Liste vor dem Klick schließen
      liste.addEventListener("mousedown", (e) => e.preventDefault());
      liste.addEventListener("click", (e) => {
        const eintrag = e.target.closest(".dropdown-item");
        if (eintrag) waehlen(eintrag.textContent);
      });

      feld.addEventListener("keydown", (e) => {
        const eintraege = [...liste.querySelectorAll(".dropdown-item")];
        const aktiv = eintraege.findIndex((eintrag) => eintrag.classList.contains("active"));

        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
          e.preventDefault();
          if (!liste.classList.contains("show")) zeigen();
          const naechster =
            e.key === "ArrowDown"
              ? (aktiv + 1) % eintraege.length
              : (aktiv - 1 + eintraege.length) % eintraege.length;
          eintraege.forEach((eintrag, i) => eintrag.classList.toggle("active", i === naechster));
          eintraege[naechster]?.scrollIntoView({ block: "nearest" });
        } else if (e.key === "Enter") {
          e.preventDefault();
          if (aktiv >= 0) waehlen(eintraege[aktiv].textContent);
          else {
            schliessen();
            speichereSchriften(feld);
          }
        } else if (e.key === "Escape") {
          schliessen();
        }
      });
    });
  }
  // -----------------------------

  let pages = {};

  try {
    // Fetch dynamic templates from backend
    const templatesResponse = await fetch(config.templatesUrl);
    if (templatesResponse.ok) {
      const templates = await templatesResponse.json();
      templates.forEach((template) => {
        pages[template.name] = {
          name: template.name,
          filename: template.filename,
          file: template.file,
          url: template.url,
          title: template.title,
          folder: template.folder,
          description: template.description,
        };
      });
    }

    // Fetch current campaign structure
    const response = await fetch(config.rawStructureUrl);
    let campaignPages = {};
    if (response.ok) {
      campaignPages["currentCampaign"] = {
        name: "Basis-Seite",
        filename: "index.html",
        file: config.rawStructureUrl,
        url: config.rawStructureUrl,
        title: "Basis-Seite",
        folder: "Kampagne",
        description: "Hauptseite der Kampagne",
        type: "main",
      };
    }

    // Fetch thank you page structure
    const dankeResponse = await fetch(config.rawDankeStructureUrl);
    if (dankeResponse.ok) {
      campaignPages["thankYouPage"] = {
        name: "Dankeseite",
        filename: "danke.html",
        file: config.rawDankeStructureUrl,
        url: config.rawDankeStructureUrl,
        title: "Dankeseite",
        folder: "Kampagne",
        description: "Seite nach Formular-Abschluss",
        type: "danke",
      };
    }

    pages = { ...campaignPages, ...pages };
  } catch (error) {
    console.error("Fehler beim Laden der Templates oder Kampagnenstruktur:", error);
  }

  const keys = Object.keys(pages);

  if (keys.length > 0 && typeof Vvveb !== "undefined" && Vvveb.Builder) {
    Vvveb.Builder.init(pages[keys[0]].url, function () {
      Vvveb.Gui?.init();
      Vvveb.FileManager?.init();
      Vvveb.SectionList?.init();
      Vvveb.StyleList?.init();
      Vvveb.TreeList?.init();
      Vvveb.Breadcrumb?.init();
      if (document.getElementById("css-editor")) {
        Vvveb.CssEditor?.init();
      }

      /* options */
      Vvveb.FileManager.addPages(pages);
      Vvveb.FileManager.loadPage(pages[keys[0]].name);
      Vvveb.Gui.toggleRightColumn(false);

      pruefeTerminbuchung();
      zeigeHinweisBeimAuswaehlen();
    });
  }

  const sidebar = document.getElementById("sidebarMenu");
  if (sidebar) {
    sidebar.classList.add("contracted");
  }

  // Easy/Expert Mode removed - always expert now.
  document.body.classList.remove("easy-mode");
  // Consolidated Save Logic
  const baseUrl = config.saveStructureUrl;
  const saveBtn = document.getElementById("save-btn");

  function isCurrentPageDanke(pageOverride) {
    const pageName =
      (pageOverride && pageOverride.name) ||
      (typeof Vvveb !== "undefined" && Vvveb.FileManager ? Vvveb.FileManager.getCurrentPage() : "");
    const pageData =
      pageOverride ||
      (typeof Vvveb !== "undefined" && Vvveb.FileManager ? Vvveb.FileManager.getPageData() : null);

    // 1. Explicit Main / Basis-Seite metadata (highest priority when explicitly selected)
    if (pageName === "Basis-Seite" || pageData?.type === "main" || pageName === "Landingpage") {
      return false;
    }
    if (pageData?.filename === "index.html" && pageData?.type !== "danke") {
      return false;
    }

    // 2. Explicit Danke Page metadata
    if (pageName === "Dankeseite" || pageData?.type === "danke") return true;
    if (pageData?.filename === "danke.html" || (pageData?.file && pageData.file.includes("danke")))
      return true;
    if (pageName && pageName.toLowerCase().includes("danke")) return true;

    // 3. Current URL from FileManager or active page
    const currentUrl =
      (pageData && pageData.url) ||
      (typeof Vvveb !== "undefined" &&
        Vvveb.FileManager &&
        Vvveb.FileManager.getCurrentUrl &&
        Vvveb.FileManager.getCurrentUrl()) ||
      "";
    if (
      currentUrl.includes("raw-danke-structure") ||
      currentUrl.includes("danke.html") ||
      currentUrl.includes("/danke")
    ) {
      return true;
    }
    if (currentUrl.includes("raw-structure") || currentUrl.includes("index.html")) {
      return false;
    }

    // 4. URLs of the loaded iframe (fallback)
    const iframeSrc =
      (typeof Vvveb !== "undefined" &&
        Vvveb.Builder &&
        Vvveb.Builder.iframe &&
        Vvveb.Builder.iframe.getAttribute("src")) ||
      "";
    let iframeHref = "";
    try {
      iframeHref = Vvveb.Builder.iframe?.contentWindow?.location?.href || "";
    } catch (e) {}

    if (
      iframeSrc.includes("raw-danke-structure") ||
      iframeSrc.includes("danke.html") ||
      iframeHref.includes("raw-danke-structure") ||
      iframeHref.includes("/danke")
    ) {
      return true;
    }
    if (
      iframeSrc.includes("raw-structure") ||
      iframeHref.includes("raw-structure") ||
      iframeSrc.includes("index.html")
    ) {
      return false;
    }

    // 5. Content signature check: If the canvas contains thank-you content signature
    const html =
      typeof Vvveb !== "undefined" && Vvveb.Builder && Vvveb.Builder.getHtml
        ? Vvveb.Builder.getHtml()
        : "";
    if (
      html &&
      (html.includes("Vielen Dank!") ||
        html.includes("<title>Vielen Dank") ||
        html.includes("<title>Danke</title>"))
    ) {
      const hasMainComponents =
        html.includes("data-component-contactform") ||
        html.includes("data-component-gluecksrad") ||
        html.includes("data-component-reaktionsspiel") ||
        html.includes("data-component-slotmachine");
      if (!hasMainComponents) {
        return true;
      }
    }

    return false;
  }

  function updateSaveButtonText(pageData) {
    if (!saveBtn) return;
    const isDanke = isCurrentPageDanke(pageData);
    const span = saveBtn.querySelector("span.button-text span");
    if (span) {
      span.textContent = isDanke ? "Dankeseite speichern" : "Landingpage speichern";
    }
  }

  // Keep save button text in sync when page is changed from the side panel or iframe
  window.addEventListener("Vvveb.FileManager.loadPage", (e) => {
    updateSaveButtonText(e.detail);
  });
  window.addEventListener("Vvveb.iframe.loaded", () => {
    updateSaveButtonText();
  });
  window.addEventListener("Vvveb.Builder.iframeLoaded", () => {
    updateSaveButtonText();
  });

  updateSaveButtonText();

  if (saveBtn) {
    saveBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (typeof Vvveb === "undefined" || typeof cs === "undefined") return;

      document.activeElement?.blur?.();

      const isDanke = isCurrentPageDanke();
      const targetText = isDanke ? "die Dankeseite" : "die Landingpage";

      cs.notifyConfirm(`Möchtest du ${targetText} wirklich speichern?`, "Speichern bestätigen", {
        icon: "question",
        confirmButtonText: "Ja, speichern!",
        customClass: {
          confirmButton: "btn btn-primary me-3",
          cancelButton: "btn btn-secondary",
        },
      }).then((isConfirmed) => {
        if (isConfirmed) {
          if (!isDanke) {
            Vvveb.Builder.save(
              { file: "index.html", type: "main" },
              baseUrl,
              (data) => {
                cs.notifySuccess("Landingpage erfolgreich gespeichert!", "Speichern");
              },
              (error) => {
                cs.notifyError("Fehler beim Speichern der Landingpage!", "Fehler");
              },
            );
          } else {
            Vvveb.Builder.save(
              { file: "danke.html", type: "danke" },
              baseUrl,
              (data) => {
                cs.notifySuccess("Dankeseite erfolgreich gespeichert!", "Speichern");
              },
              (error) => {
                cs.notifyError("Fehler beim Speichern der Dankeseite!", "Fehler");
              },
            );
          }
        }
      });
    });

    // Verhindere, dass VvvebJs den Button dauerhaft deaktiviert
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "disabled" && saveBtn.hasAttribute("disabled")) {
          saveBtn.removeAttribute("disabled");
        }
      });
    });
    observer.observe(saveBtn, { attributes: true });

    // Strg+S / Cmd+S abfangen, bevor builder.js es verarbeitet (dessen Gui.save findet
    // an #save-btn keine data-vvveb-url und speichert dann gar nicht)
    const onSaveShortcut = function (e) {
      if ((e.ctrlKey || e.metaKey) && (e.key === "s" || e.key === "S")) {
        e.preventDefault();
        e.stopPropagation();
        saveBtn.click();
      }
    };
    window.addEventListener("keydown", onSaveShortcut, true);

    // Tastendrücke im Canvas erreichen das Hauptfenster nicht -> auch am iframe-Fenster abfangen
    const bindFrameShortcut = () => {
      const frameWindow = window.FrameWindow;
      if (frameWindow) {
        frameWindow.removeEventListener("keydown", onSaveShortcut, true);
        frameWindow.addEventListener("keydown", onSaveShortcut, true);
      }
    };
    window.addEventListener("Vvveb.iframe.loaded", bindFrameShortcut);
    bindFrameShortcut();
  }
});

// Helper to translate object values
function translateComponents() {
  if (!window.Vvveb || !window.Vvveb.Components) return;

  const translations = {
    // Groups
    Typography: "Typografie",
    Layout: "Layout",
    Components: "Komponenten",
    Form: "Formular",
    Media: "Medien",

    // Components
    "Grid Row": "Grid Zeile",
    "Grid Column": "Grid Spalte",
    Heading: "Überschrift",
    Image: "Bild",
    Link: "Link",
    Button: "Button",
    Text: "Text",
    Map: "Karte",
    Video: "Video",
    Paragraph: "Absatz",
    Blockquote: "Zitat",
    "Horizontal Rule": "Trennlinie",
    List: "Liste",
    Label: "Label",
    Input: "Eingabefeld",
    Select: "Auswahl",
    "Text Area": "Textbereich",
    Checkbox: "Checkbox",
    "Radio Button": "Radio-Button",
    Table: "Tabelle",
    "Table Row": "Tabellenzeile",
    "Table Cell": "Tabellenzelle",
    "Image Gallery": "Bildergalerie",

    // Common Properties (Labels often generated from keys, but sometimes defined)
    Background: "Hintergrund",
    Border: "Rahmen",
    Margin: "Außenabstand",
    Padding: "Innenabstand",
    Size: "Größe",
    Alignment: "Ausrichtung",
    Display: "Anzeige",
    Font: "Schriftart",
    Color: "Farbe",
    Width: "Breite",
    Height: "Höhe",
    Top: "Oben",
    Bottom: "Unten",
    Left: "Links",
    Right: "Rechts",
    Center: "Mitte",
    Justify: "Blocksatz",
  };

  for (const key in window.Vvveb.Components) {
    const component = window.Vvveb.Components[key];
    if (component.name && translations[component.name]) {
      component.name = translations[component.name];
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const builder = document.getElementById("vvveb-builder");
  if (!builder) return;

  // Execute multiple times to catch delayed loading
  translateComponents();
  setTimeout(translateComponents, 500);
  setTimeout(translateComponents, 2000);
});

/**
 * Die Buchungskomponente lebt auf der Seite, ihre Zeiten stehen aber in den Kampagnendetails.
 * Ohne Hinweis platziert man sie hier und wundert sich später über "keine Termine buchbar".
 */
function pruefeTerminbuchung() {
  const config = window.campaignStructureConfig || {};
  if (config.buchungAktiv) return;

  const zeige = () => {
    const doc = window.FrameDocument;
    if (!doc || !doc.querySelector("[data-component-terminbuchung]")) return false;
    if (document.getElementById("terminbuchung-hinweis-builder")) return true;

    const hinweis = document.createElement("div");
    hinweis.id = "terminbuchung-hinweis-builder";
    hinweis.className = "alert alert-warning d-flex align-items-center gap-2 m-2";
    hinweis.style.cssText =
      "position:fixed;bottom:16px;left:50%;transform:translateX(-50%);z-index:2000;max-width:640px;box-shadow:0 8px 24px rgba(0,0,0,.15);";
    hinweis.innerHTML =
      "<span>Die Terminbuchung ist für diese Kampagne noch <strong>nicht aktiv</strong> — " +
      "Besucher sehen sonst nur den Hinweis, dass keine Termine buchbar sind. " +
      "Zeiten und Aktivierung stehen in den Kampagnendetails.</span>" +
      '<a class="btn btn-sm btn-warning text-nowrap" target="_blank" rel="noopener" href="' +
      (config.buchungEinstellungenUrl || "#") +
      '#booking">Einstellungen öffnen</a>' +
      '<button type="button" class="btn-close ms-2" aria-label="Schließen"></button>';

    hinweis.querySelector(".btn-close").addEventListener("click", () => hinweis.remove());
    document.body.appendChild(hinweis);
    return true;
  };

  // Der Seiteninhalt steht erst nach dem Laden des iframes bereit
  if (zeige()) return;
  let versuche = 0;
  const timer = setInterval(() => {
    if (zeige() || ++versuche > 20) clearInterval(timer);
  }, 500);
}

/**
 * Blendet beim Auswählen der Buchungskomponente einen Verweis auf die Kampagnendetails ein.
 * Der Builder kennt kein Auswahl-Event, deshalb hängen wir uns an loadNodeComponent.
 */
function zeigeHinweisBeimAuswaehlen() {
  if (typeof Vvveb === "undefined" || !Vvveb.Builder || Vvveb.Builder.loadNodeComponentOriginal) {
    return;
  }

  Vvveb.Builder.loadNodeComponentOriginal = Vvveb.Builder.loadNodeComponent;
  Vvveb.Builder.loadNodeComponent = function (node) {
    const ergebnis = Vvveb.Builder.loadNodeComponentOriginal.apply(this, arguments);

    const panel = document.querySelector(".component-properties");
    document.querySelector(".terminbuchung-panel-hinweis")?.remove();

    if (panel && node?.closest?.("[data-component-terminbuchung]")) {
      const url = window.campaignStructureConfig?.buchungEinstellungenUrl;
      const box = document.createElement("div");
      box.className = "terminbuchung-panel-hinweis alert alert-info m-2 small";
      box.innerHTML =
        "Buchbare Zeiten, Termindauer, Reservierung und Erinnerung stehen in den " +
        "<strong>Kampagnendetails</strong>, nicht hier." +
        (url
          ? ' <a target="_blank" rel="noopener" href="' + url + '#booking">Dort öffnen</a>'
          : "");
      panel.prepend(box);
    }

    return ergebnis;
  };
}
